// Auto-search (search-as-you-type) helpers for the Browse-Image picker.
// Design decision D-15: image search runs automatically as you type
// (debounced), no need to press the search icon. The icon/Enter remain as
// affordances but are not required to trigger the search.

// Minimum keyword length before an automatic search fires. Keywords this short
// keep the initial (keyword-suggestion) view instead of hitting the API.
export const SEARCH_LENGTH_LIMIT = 2;

// Debounce window for the search-as-you-type behavior.
export const AUTOSEARCH_DEBOUNCE_MS = 300;

// Normalize a raw input value into the query that actually gets searched.
export function normalizeQuery(keyword) {
  return (keyword || "").trim();
}

// Decide whether a typed keyword should trigger an automatic (debounced)
// search. Returns false when the keyword is too short, or when it exactly
// matches the query that was already searched (e.g. the user pressed Enter or
// the search icon) so typing does not double-fire the same request.
export function shouldAutoSearch(keyword, lastQuery, limit = SEARCH_LENGTH_LIMIT) {
  const q = normalizeQuery(keyword);
  if (q.length <= limit) {
    return false;
  }
  if (q === normalizeQuery(lastQuery)) {
    return false;
  }
  return true;
}
